loadjs.ready(['jquery', 'core'], function() {
    var $productGalleryModal = $('#product-gallery-modal');
    var openSlide;
    var pinchZoomInstance;
    var initZoom = function(el) {
        pinchZoomInstance = new PinchZoom(el, {
            container: el.parentNode,
            draggableUnzoomed: false,
            minZoom: 1,
            tapZoomFactor: 3,
            use2d: false,
            setOffsetsOnce: true,
            onZoomEnd: function(obj, event) {
                if (
                    event.zoomFactor === obj.minZoom
                    && (obj.offset.x !== obj.initialOffset.x || obj.offset.y !== obj.initialOffset.y)
                ) {
                    pinchZoomInstance.reset();
                }
            }
        });
    };

    var destroyZoom = function() {
        pinchZoomInstance.destroy();
        pinchZoomInstance = null;
    };

    $('body').on('click', '.gallery-open', function(e) {
        e.preventDefault();
        if (!$productGalleryModal.data('slider')) {
            var $gallerySlider = $productGalleryModal.find('.slider');
            var bullets = $gallerySlider.data('bullets');
            var gallerySlider = $gallerySlider.slider({bullets: bullets !== undefined ? parseInt(bullets) : true})[0].slider;
            var handlePinchZoom = function(slideIdx) {
                var $img = $gallerySlider.find('.slider-frame').children().eq(slideIdx)
                    .find('.pinch-zoom-container img');

                if (pinchZoomInstance) {
                    destroyZoom();
                }

                if ($img.length) {
                    initZoom($img[0]);
                }
            }
            $productGalleryModal.data('slider', gallerySlider);
            $productGalleryModal.on('slide', function() {
                var currentSlide = gallerySlider.currentSlide();
                handlePinchZoom(currentSlide);
                if (typeof product !== 'undefined') {
                    gtag('event', 'product_gallery_slide', {
                        'event_label': product.id,
                        'event_category': 'product_events',
                        'value': currentSlide,
                        'non_interaction': true
                    });
                }

            });
            $productGalleryModal
                .on('modal:shown', function() {
                    gallerySlider.reposition();
                    gallerySlider.slideTo(openSlide);
                    handlePinchZoom(gallerySlider.currentSlide());
                    $gallerySlider.parent().css({opacity: 1});
                })
                .on('modal:hidden', function() {
                    $gallerySlider.parent().css({opacity: 0});
                    if (pinchZoomInstance) {
                        pinchZoomInstance.reset();
                    }
                })
                .data('modal-options', {'speed': 0});

            var throttled = false;
            var detect = null;
            var start = null;
            var ts = null;
            var threshold = 10;
            var width = null;

            $productGalleryModal.on('touchstart', function(e) {
                start = detect = ts = null;
                if (pinchZoomInstance?.zoomFactor > 1 || e.touches.length > 1) {
                    return;
                }
                detect = {
                    x: e.touches[0].clientX,
                    y: e.touches[0].clientY,
                }
                ts = (new Date()).getTime();
                $productGalleryModal.data('diff', null);
                width = $gallerySlider.width();
            })
            $productGalleryModal.on('touchmove', function(e) {
                if (e.touches.length > 1) {
                    return;
                }
                if (start === null && detect === null) {
                    return;
                }

                if (!throttled) {
                    throttled = true;
                    window.requestAnimationFrame(function() {
                        var diff;
                        if (start === null) {
                            if (detect) {
                                diff = {
                                    x: e.touches[0].clientX - detect.x,
                                    y: e.touches[0].clientY - detect.y
                                };

                                var abs = {
                                    x: Math.abs(diff.x),
                                    y: Math.abs(diff.y)
                                };

                                if (abs.x >= threshold && abs.x > abs.y) {
                                    detect = start = null;
                                } else if (abs.y >= threshold && abs.y > abs.x) {
                                    start = {
                                        x: e.touches[0].clientX,
                                        y: e.touches[0].clientY
                                    }
                                    $gallerySlider.css('--frame-overflow-x', 'hidden');
                                }
                            }
                        } else {
                        }
                        throttled = false;
                    })
                }
            })

            $productGalleryModal.on('touchend', function(e) {
                $gallerySlider.removeAttr('style');
                if (start === null) {
                    return;
                }
                e.preventDefault();
                window.requestAnimationFrame(function() {
                    var diff = $productGalleryModal.data('diff');
                    var duration = 100;
                    var height = $(window).height();

                    if (!diff) {
                        return;
                    }

                    var velocity = Math.abs(diff.y) / ((new Date()).getTime() - ts);


                    if (Math.abs(diff.y) >= (height / 3) || velocity >= 0.2) {
                        var y = diff.y > 0 ? height : -height;
                        $productGalleryModal.css({
                            'transform': 'translate3d(0, ' +  y + 'px, 0)',
                            'transition': 'transform ' + duration + 'ms',
                        });
                        setTimeout(function() {
                            $productGalleryModal
                                .one('modal:hidden', function() {
                                    $productGalleryModal.css({
                                        'transform': 'unset',
                                        'transition': 'unset',
                                    })
                                }).modal('hide');
                        }, duration)
                    } else {
                        $productGalleryModal.css({
                            'transform': 'translate3d(0, 0, 0)',
                            'transition': 'transform ' + duration + 'ms',
                        });
                    }
                })
            })
        }
        openSlide = parseInt($(this).data('slide'));
        $productGalleryModal.modal('show');
        if (typeof product !== 'undefined') {
            gtag('event', 'product_gallery_open', {
                'event_label': product.id,
                'event_category': 'product_events',
                'value': openSlide,
                'non_interaction': true
            });
        }

        return false;
    })
})
